/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  NotificationTemplatePreviewResponse,
  NotificationTemplateResponse,
  NotificationType,
  PreviewNotificationTemplateRequest,
  ResetNotificationTemplateRequest,
  SaveNotificationTemplateRequest,
  SendTestNotificationTemplateEmailRequest,
  SupportedNotificationTemplatesResponse,
  V1TenantNotificationTemplatesListError,
  V1TenantNotificationTemplatesPreviewCreateError,
  V1TenantNotificationTemplatesResetCreateError,
  V1TenantNotificationTemplatesSendTestCreateError,
  V1TenantNotificationTemplatesSupportedListError,
  V1TenantNotificationTemplatesUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class NotificationTemplates<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesSupportedList
   * @request GET:/api/v1/tenant/notification-templates/supported
   * @secure
   * @response `200` `SupportedNotificationTemplatesResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesSupportedList = (params: RequestParams = {}) =>
    this.http.request<
      SupportedNotificationTemplatesResponse,
      V1TenantNotificationTemplatesSupportedListError
    >({
      path: `/api/v1/tenant/notification-templates/supported`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesList
   * @request GET:/api/v1/tenant/notification-templates
   * @secure
   * @response `200` `NotificationTemplateResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesList = (
    query?: {
      eventType?: NotificationType;
      language?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<NotificationTemplateResponse, V1TenantNotificationTemplatesListError>({
      path: `/api/v1/tenant/notification-templates`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesUpdate
   * @request PUT:/api/v1/tenant/notification-templates
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesUpdate = (
    data: SaveNotificationTemplateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1TenantNotificationTemplatesUpdateError>({
      path: `/api/v1/tenant/notification-templates`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesPreviewCreate
   * @request POST:/api/v1/tenant/notification-templates/preview
   * @secure
   * @response `200` `NotificationTemplatePreviewResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesPreviewCreate = (
    data: PreviewNotificationTemplateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      NotificationTemplatePreviewResponse,
      V1TenantNotificationTemplatesPreviewCreateError
    >({
      path: `/api/v1/tenant/notification-templates/preview`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesSendTestCreate
   * @request POST:/api/v1/tenant/notification-templates/send-test
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesSendTestCreate = (
    data: SendTestNotificationTemplateEmailRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1TenantNotificationTemplatesSendTestCreateError>({
      path: `/api/v1/tenant/notification-templates/send-test`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags NotificationTemplates
   * @name V1TenantNotificationTemplatesResetCreate
   * @request POST:/api/v1/tenant/notification-templates/reset
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1TenantNotificationTemplatesResetCreate = (
    data: ResetNotificationTemplateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1TenantNotificationTemplatesResetCreateError>({
      path: `/api/v1/tenant/notification-templates/reset`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
